import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'
import pic9 from './pic9.jpg'
import pic10 from './pic10.jpg'
import pic11 from './pic11.jpg'
import pic12 from './pic12.jpg'
import pic13 from './pic13.jpg'
import pic14 from './pic14.jpg'
import pic15 from './pic15.jpg'
import pic16 from './pic16.jpg'
import pic17 from './pic17.jpg'





const Id2 = () => {

    const detail = 
        {
            id:31,
            imgSrc:cover,
            ini:'Training SATIT Primary School Students on Zoonoses (Third Day)',
            href:'',
            element:'',
            topic:`The excitement and learning continued into Day 3! On Monday, 29 June 2026, the LUCENT International Collaboration Unit, in partnership with the IJL PRESTO International Joint Laboratory Project, organized a learning activity under the theme "Guardian Hero Activity." The program was designed to strengthen students' leadership, critical thinking, problem-solving, and active participation in zoonotic disease prevention through four interactive, real-life simulation stations.
                    Throughout the activity, students enthusiastically engaged in every learning station, embracing their roles as "Guardian Heroes." They practiced critical thinking, decision-making, and problem-solving while responding to realistic scenarios, enabling them to develop a better understanding of zoonotic disease surveillance and prevention. The knowledge and practical skills gained from the activity can be readily applied to their daily lives, fostering responsible behaviors that contribute to healthier communities.`,
            inform:``,
            link1:`https://lucent.ams.cmu.ac.th/view_activity.html?id=52`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        {
            imageSrc: pic9,
            alt: 'pic9',
            title: 'pic9',
            thumbnailImageSrc: pic9
        },
        {
            imageSrc: pic10,
            alt: 'pic10',
            title: 'pic10',
            thumbnailImageSrc: pic10
        },
        {
            imageSrc: pic11,
            alt: 'pic11',
            title: 'pic11',
            thumbnailImageSrc: pic11
        },
        {
            imageSrc: pic12,
            alt: 'pic12',
            title: 'pic12',
            thumbnailImageSrc: pic12
        },
        {
            imageSrc: pic13,
            alt: 'pic13',
            title: 'pic13',
            thumbnailImageSrc: pic13
        },
        {
            imageSrc: pic14,
            alt: 'pic14',
            title: 'pic14',
            thumbnailImageSrc: pic14
        },
        {
            imageSrc: pic15,
            alt: 'pic15',
            title: 'pic15',
            thumbnailImageSrc: pic15
        },
        {
            imageSrc: pic16,
            alt: 'pic16',
            title: 'pic16',
            thumbnailImageSrc: pic16
        },
        {
            imageSrc: pic17,
            alt: 'pic17',
            title: 'pic17',
            thumbnailImageSrc: pic17
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
